import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "accounting";
const version = "v1";

// Chart of Accounts
export const fetchV1COAs = async (
  page = 1,
  pageSize = 5,
  account_type = "",
  account_sub_type = "",
  supplier = "",
  customer = "",
  paymentMethod = null,
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/heads/?page_size=${pageSize}&page=${page}&account_type=${encodeURIComponent(
    account_type
  )}&account_sub_type=${encodeURIComponent(account_sub_type)}`;

  if (supplier) {
    URL += `&supplier=${encodeURIComponent(supplier)}`;
  }
  if (customer) {
    URL += `&customer=${encodeURIComponent(customer)}`;
  }
  if (paymentMethod) {
    URL += `&payment_method=true`;
  }

  console.log("Account Heads API:", account_type, URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching account heads:", error);
    throw error;
  }
};

export const searchV1COAs = async (
  query = "",
  page = 1,
  pageSize = 8,
  account_type = ""
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/heads?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  if (account_type) {
    URL += `&account_type=${encodeURIComponent(account_type)}`;
  }

  console.log("Search COA API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching COAs:", error);
    throw error;
  }
};

export const createV1COA = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/heads/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating COA at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

// Journal Entries
export const fetchV1Journals = async (
  page = 1,
  pageSize = 5,
  transaction_type = ""
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 5;
  let URL = `${API_BASE_URL}/${content}/${version}/journals/?page_size=${pageSize}&page=${page}&transaction_type=${encodeURIComponent(
    transaction_type
  )}`;

  console.log("Journals API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching Journals:", error);
    throw error;
  }
};

export const fetchV1AccountJournals = async (
  page = 1,
  pageSize = 5,
  accountCode = null
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 5;
  let URL = `${API_BASE_URL}/${content}/${version}/journals/account/${accountCode}/?page_size=${pageSize}&page=${page}`;

  console.log("Account Journals API:", URL, accountCode, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching account journals:", error);
    throw error;
  }
};

export const createV1Journal = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/journals/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating Journal at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

// Ledgers
export const fetchV1Ledgers = async (
  page = 1,
  pageSize = 5,
  account_type = "",
  account_sub_type = ""
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 5;
  let URL = `${API_BASE_URL}/${content}/${version}/ledgers/?page_size=${pageSize}&page=${page}&account_type=${encodeURIComponent(
    account_type
  )}&account_sub_type=${encodeURIComponent(account_sub_type)}`;

  console.log("Ledgers API:", account_type, URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching ledgers:", error);
    throw error;
  }
};

export const fetchV1AccountLedgers = async (
  page = 1,
  pageSize = 5,
  accountCode = null
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 5;
  let URL = `${API_BASE_URL}/${content}/${version}/ledgers/account/${accountCode}/?page_size=${pageSize}&page=${page}`;

  console.log("Account Ledgers API:", URL, accountCode, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching account ledgers:", error);
    throw error;
  }
};

export const makePaymentMethodV1 = async (accountCode) => {
  const URL = `${API_BASE_URL}/${content}/${version}/make-payment-method/${accountCode}/`;

  try {
    const response = await api.post(URL);
    return response.data;
  } catch (error) {
    console.error("Error make payment at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

// invoices
export const fetchV1Invoices = async (
  page = 1,
  pageSize = 5,
  payable = null,
  receivable = null,
  type = null
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 5;
  let URL = `${API_BASE_URL}/${content}/${version}/invoices/?page_size=${pageSize}&page=${page}`;

  if (payable) {
    URL += `&payable=${encodeURIComponent(payable)}`;
  }

  if (receivable) {
    URL += `&receivable=${encodeURIComponent(receivable)}`;
  }

  if (type) {
    URL += `&type=${encodeURIComponent(type)}`;
  }

  console.log("invoices API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};

export const fetchV1Invoice = async (invoiceNumber = null) => {
  let URL = `${API_BASE_URL}/${content}/${version}/invoices/${invoiceNumber}/`;

  console.log("invoice API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching invoice:", error);
    throw error;
  }
};

// over view
export const fetchV1AssetOverview = async () => {
  let URL = `${API_BASE_URL}/${content}/${version}/asset-overview/`;

  console.log("Asset Overview API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset overview:", error);
    throw error;
  }
};
